export default __webpack_public_path__ + "static/media/Sandals of the Faceless Chaos.3014de3c.jpg";